import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getPayoutMethods } from "constants/apiUrls";
import { PayoutMethodEnum } from "enum/common";

const payoutApi = createApi({
  reducerPath: "payoutApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_URL }),
  endpoints: (builder) => ({
    payoutMethods: builder.query<any, { type: PayoutMethodEnum; uuid: string }>(
      {
        query: (arg) => {
          const { type, uuid } = arg;
          const mandatoryHeaders = {
            "bludot-app-name": "business-rewards",
            "Content-Type": "application/json",
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("token") || ""
            )}`,
          };
          return {
            url: getPayoutMethods(type, uuid),
            headers: mandatoryHeaders,
          };
        },
      }
    ),
  }),
});

export const { usePayoutMethodsQuery, useLazyPayoutMethodsQuery } = payoutApi;
export default payoutApi;
